import PropTypes from 'prop-types';

import { GCrossIcon } from '../../app/icons/common-icons';
import { SuspenseWrapper, getPrivacyComponentContent } from '../../helpers/dynamic-import-helper';
import PopupContentLoader from '../PopupcontentLoader';

const PrivacyContent = getPrivacyComponentContent();

export default function PrivacyModal(props) {
  return (
    <div className="g-modal-window">
      <div className="g-modal-wrapper alternate policy-modal">
        <header className="g-modal-head">
          <h4 className="title-sm">Privacy Policy</h4>
          <button data-testid="privacyCloseBtn" type="button" className="nostyle g-modal-close" onClick={props.onClose}>
            <GCrossIcon />
          </button>
        </header>
        <SuspenseWrapper fallback={<PopupContentLoader />}>
          <PrivacyContent />
        </SuspenseWrapper>
      </div>
    </div>
  );
}


PrivacyModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};
